import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Commande } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class CommandeService {
  constructor(private httpClient: HttpClient) { }

  // les commandes pour un id donné
  getCommandesById(id) {
    return this.httpClient
      .post<any>(`${environment.apiEndPoint}commandes/read`, JSON.stringify({ id: `${id}` }))
      .pipe(
        map(res => res ? res.document.records as Commande[] : []),
        catchError(this.handleError)
      );
  }

  // la commande pour un id donné
  getCommandeById(id) {
    return this.httpClient
      .post<any>(`${environment.apiEndPoint}commande/read_one`, JSON.stringify({ id: `${id}` }))
      .pipe(
        map(res => res.document),
        catchError(this.handleError)
      );
  }

  saveCommande(object: any) {
    return this.httpClient
      .post<any>(`${environment.apiEndPoint}commande/create`, object)
      .pipe(
        map(res => res.document),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Promise<any> {
    let retour = error?.error?.message || error?.message || error;
    if(error?.error?.data) retour += '<br />'+error?.error?.data;
    return Promise.reject(retour);
  }
}